import {
  toHex,
  mix,
  getLuminance,
  getContrast,
  hsla,
  parseToHsla,
  parseToRgba,
} from 'color2k';

// LA COULEUR SECONDAIRE est ce qui se pose sur la Couleur du Widget : texte, icone, croix, visage
// du robot. Une seule regle, ici, pour la bulle, les lanceurs, le robot et le Constructeur.
export const BLANC = '#fff';
// Si le calcul du fonce echouait, ce quasi-noir lit au moins 6:1 sur toute couleur claire.
export const ENCRE_DE_SECOURS = '#101317';

// 3:1, le minimum du RGAA pour un element graphique ; 4,5:1 pour un texte.
const BLANC_LISIBLE = 3;
const FONCE_LISIBLE = 4.5;

// L'ANCIENNE REGLE, quand l'adaptation est desactivee : seules les couleurs presque blanches
// (clarte au-dessus de 225 sur 255) passent au fonce, sinon le lanceur y deviendrait invisible.
const presqueBlanche = couleur => {
  const [r, g, b] = parseToRgba(couleur);
  return (r * 299 + g * 587 + b * 114) / 1000 > 225;
};

// TROP CLAIRE POUR PORTER DU BLANC. Adaptee : le blanc dessus n'atteint pas 3:1. Sinon, presque
// blanche. Une couleur illisible garde le blanc.
export const isWidgetColorLighter = (color, adaptee = true) => {
  try {
    if (!adaptee) return presqueBlanche(color);
    return getContrast(color, '#ffffff') < BLANC_LISIBLE;
  } catch (error) {
    return false;
  }
};

// LE FONCE DE LA MEME TEINTE : la couleur assombrie, au plus clair qui atteint 4,5:1 sur elle. Plus
// il s'eclaircit, moins il contraste : la recherche coupe en deux, au pourcent de clarte pres.
export const fonceDeLaTeinte = couleur => {
  try {
    const [teinte, saturation, clarte] = parseToHsla(couleur);
    const fonce = pourcent =>
      toHex(hsla(teinte, saturation, pourcent / 100, 1));
    const lisible = pourcent =>
      getContrast(fonce(pourcent), couleur) >= FONCE_LISIBLE;
    if (!lisible(0)) return ENCRE_DE_SECOURS;

    let bas = 0;
    let haut = Math.floor(clarte * 100);
    while (bas < haut) {
      const milieu = Math.ceil((bas + haut) / 2);
      if (lisible(milieu)) bas = milieu;
      else haut = milieu - 1;
    }
    return fonce(bas);
  } catch (error) {
    return ENCRE_DE_SECOURS;
  }
};

// UNE COULEUR QUE LA REGLE SAIT LIRE : #fff, #1f93ff, rgb(), hsl() ou un nom anglais.
export const estUneCouleur = couleur => {
  try {
    parseToRgba(couleur);
    return true;
  } catch (error) {
    return false;
  }
};

export const couleurSecondaire = (couleur, adaptee = true) =>
  isWidgetColorLighter(couleur, adaptee) ? fonceDeLaTeinte(couleur) : BLANC;

export const adjustColorForContrast = (color, backgroundColor) => {
  const targetRatio = 3.1;
  const MAX_ITERATIONS = 20;
  let adjustedColor = color;

  for (let iteration = 0; iteration < MAX_ITERATIONS; iteration += 1) {
    const currentRatio = getContrast(adjustedColor, backgroundColor);
    if (currentRatio >= targetRatio) {
      break;
    }
    const adjustmentDirection =
      getLuminance(adjustedColor) < 0.5 ? '#fff' : '#151718';
    adjustedColor = mix(adjustedColor, adjustmentDirection, 0.05);
  }

  return toHex(adjustedColor);
};
